module.exports = __webpack_public_path__ + "static/media/menu.981ecca4.svg";